import script from "./TestnetLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestnetLabel.vue?vue&type=script&setup=true&lang=ts"

import "./TestnetLabel.vue?vue&type=style&index=0&id=7c95cd2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c95cd2a"]])

export default __exports__